import { Maximize2, Minimize2 } from 'lucide-preact';
import { Statement } from '../../components/Statement';
import { ChartCard } from '../../components/ui';
import {
  STATEMENT_TYPE_OPTIONS,
  VALUE_MODE_OPTIONS,
  type StatementType,
  type ValueMode,
} from './financialStatements.config';

interface StatementTableSectionProps {
  title: string;
  currencyCode: string;
  statementType: StatementType;
  selectedPeriod: string;
  availablePeriods: string[];
  valueMode: ValueMode;
  isExpanded: boolean;
  onStatementTypeChange: (type: StatementType) => void;
  onPeriodChange: (period: string) => void;
  onValueModeChange: (mode: ValueMode) => void;
  onToggleExpand: () => void;
  onPeriodsChange: (periods: string[]) => void;
  onFilteredDataChange: (data: Map<number, Map<string, number>>) => void;
}

export function StatementTableSection({
  title,
  currencyCode,
  statementType,
  selectedPeriod,
  availablePeriods,
  valueMode,
  isExpanded,
  onStatementTypeChange,
  onPeriodChange,
  onValueModeChange,
  onToggleExpand,
  onPeriodsChange,
  onFilteredDataChange,
}: StatementTableSectionProps) {
  const showValueMode = statementType === 'cashflow' || statementType === 'income';

  return (
    <ChartCard
      className="fs-layout__table fs-table-card"
      title={`${title}${currencyCode ? ` (${currencyCode})` : ''}`}
      controls={
        <div className="fs-controls">
          <select
            className="financial-dropdown"
            value={statementType}
            onChange={(e) => onStatementTypeChange((e.target as HTMLSelectElement).value as StatementType)}
          >
            {STATEMENT_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          <select
            className="financial-dropdown"
            value={selectedPeriod}
            onChange={(e) => onPeriodChange((e.target as HTMLSelectElement).value)}
          >
            <option value="all">All Years</option>
            {availablePeriods.map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
          {showValueMode && (
            <select
              className="financial-dropdown"
              value={valueMode}
              onChange={(e) => onValueModeChange((e.target as HTMLSelectElement).value as ValueMode)}
            >
              {VALUE_MODE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          )}
          <button
            type="button"
            className="financial-icon-button"
            title={isExpanded ? 'Collapse' : 'Expand'}
            onClick={onToggleExpand}
          >
            {isExpanded ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
          </button>
        </div>
      }
    >
      <Statement
        statementType={statementType}
        selectedPeriod={selectedPeriod}
        onPeriodsChange={onPeriodsChange}
        onFilteredDataChange={onFilteredDataChange}
        valueMode={valueMode}
      />
    </ChartCard>
  );
}
